import { CartUpdateEvent } from '@theme/events';

const QUANTITY_EVENT = 'quantity-selector:update';

class CartItemsComponent extends HTMLElement {
  connectedCallback() {
    document.addEventListener(QUANTITY_EVENT, this.#onQuantityChange);
    this.addEventListener('click', this.#onClick);
    console.log('[CartItems] connectedCallback — listening for:', QUANTITY_EVENT);
  }

  disconnectedCallback() {
    document.removeEventListener(QUANTITY_EVENT, this.#onQuantityChange);
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const actionBtn = target.closest('[on\\:click]');
    if (!actionBtn) return;

    const handler = actionBtn.getAttribute('on:click') || '';
    const removeMatch = handler.match(/^\/onLineItemRemove\/(\d+)$/);
    if (removeMatch) {
      event.preventDefault();
      this.onLineItemRemove(parseInt(removeMatch[1], 10));
    }
  };

  #onQuantityChange = (event) => {
    console.log('[CartItems] quantity event received, target:', event.target);
    console.log('[CartItems] contains:', this.contains(event.target));
    console.log('[CartItems] detail:', event.detail);

    if (!this.contains(/** @type {Node} */ (event.target))) return;

    const { quantity, cartLine } = event.detail;
    console.log('[CartItems] quantity:', quantity, 'cartLine:', cartLine);

    if (cartLine == null) return;

    if (quantity === 0) {
      this.onLineItemRemove(cartLine);
    } else {
      this.#setDisabled(true);
      this.#cartChange(cartLine, quantity);
    }
  };

  onLineItemRemove(line) {
    const row = this.#getRow(line);
    if (row) {
      row.style.setProperty('--row-height', row.offsetHeight + 'px');
      row.classList.add('removing');
    }
    this.#setDisabled(true);
    this.#cartChange(line, 0);
  }

  async #cartChange(line, quantity) {
    const sectionId = this.closest('[data-section-id]')?.getAttribute('data-section-id');
    console.log('[CartItems] cartChange — line:', line, 'qty:', quantity, 'sectionId:', sectionId);

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line, quantity, ...(sectionId ? { sections: sectionId } : {}) }),
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        this.#showError(line, err.description || err.message || 'Could not update cart.');
        this.#getRow(line)?.classList.remove('removing');
        this.#setDisabled(false);
        return;
      }

      const cart = await response.json();
      console.log('[CartItems] cart.item_count:', cart.item_count, 'sections:', Object.keys(cart.sections ?? {}));

      document.dispatchEvent(
        new CartUpdateEvent(cart, 'cart-items-component', {
          itemCount: cart.item_count,
          sections: cart.sections ?? {},
        })
      );

      const sectionHtml = sectionId && cart.sections?.[sectionId];
      if (sectionHtml) {
        this.#renderSection(sectionHtml, line);
      } else {
        console.warn('[CartItems] no section HTML returned, reloading');
        window.location.reload();
      }
    } catch (e) {
      console.error('[CartItems] fetch error:', e);
      this.#getRow(line)?.classList.remove('removing');
      this.#setDisabled(false);
    }
  }

  #renderSection(sectionHtml, line) {
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const newContent =
      doc.querySelector('cart-items-component') ??
      doc.querySelector('.cart-items__wrapper');

    console.log('[CartItems] rendering new content:', newContent?.tagName);

    if (newContent) {
      this.innerHTML = newContent.innerHTML;
    } else {
      this.innerHTML = doc.body.innerHTML;
    }

    this.#setDisabled(false);
    this.#hideError(line);
  }

  #showError(line, message) {
    const container = this.querySelector(`[ref="cartItemErrorContainer-${line}"]`);
    const text = this.querySelector(`[ref="cartItemError-${line}"]`);
    container?.classList.remove('hidden');
    if (text) text.textContent = message;
  }

  #hideError(line) {
    this.querySelector(`[ref="cartItemErrorContainer-${line}"]`)?.classList.add('hidden');
  }

  #setDisabled(disabled) {
    this.classList.toggle('cart-items-disabled', disabled);
  }

  #getRow(line) {
    return /** @type {HTMLElement|null} */ (
      this.querySelectorAll('.cart-items__table-row')[line - 1] ?? null
    );
  }
}

if (!customElements.get('cart-items-component')) {
  customElements.define('cart-items-component', CartItemsComponent);
}
